import {
  AUTH_ROUTES,
  isForgotPasswordPath,
  isLoginPath,
  isPasswordChangedPath,
  isResetLinkPath,
  isSetPasswordPath,
  normalizeAuthPath,
} from '@constants/auth-routes';

/**
 * `?return=` on /login must be a same-origin relative path only (open redirect safe).
 */
export function getSafeLoginReturnUrl(): string | null {
  const raw = new URLSearchParams(window.location.search).get('return');
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) {
    return null;
  }
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) {
    return null;
  }
  return raw;
}

/** True when the current path is a marketing auth URL. */
export function isAuthMarketingPath(pathname?: string): boolean {
  const path = normalizeAuthPath(pathname ?? window.location.pathname);

  return (
    path === AUTH_ROUTES.SIGN_UP
    || path === AUTH_ROUTES.ACCOUNT_ACTIVATE
    || isLoginPath(path)
    || isForgotPasswordPath(path)
    || isResetLinkPath(path)
    || isSetPasswordPath(path)
    || isPasswordChangedPath(path)
  );
}
